import { hideNotification, showNotification } from './store/notificationSlice';
export function showTimedNotification(notification) {
    return (dispatch) => {
        dispatch(showNotification(notification));
        setTimeout(() => dispatch(hideNotification()), 10000);
    };
}
